import { Box, Flex, Grid, GridItem, Image, Img, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { BrandAssets } from 'src/config';
import { colors } from 'src/utils/colors';
import { FooterHeading } from '../common/texts/FooterHeading/footerHeading';
import { CompanyInformation } from './companyInformation';
import { Copyright } from './copyright';
import { FooterSocials } from './FooterSocials/socials';
import { Newsletter } from './Newsletter/newsletter';

export default function Footer() {
	const { t } = useTranslation();

	return (
		<>
			<Flex
				w="100%"
				h="0.5px"
			>
				<Box
					w="30%"
					bgColor={colors.primary}
				/>
				<Box
					w="70%"
					bgColor="#131313"
				/>
			</Flex>
			{/* dekstop */}
			<Box display={{ base: 'none', md: 'block' }}>
				<Flex
					bgColor="#131313"
					justify="center"
					pb="0px"
				>
					<Flex
						w="1240px"
						flexDir="column"
						color="white"
						pt="70px"
						pb="0px"
					>
						<Flex
							justify="space-between"
							pb="0px"
						>
							<Flex
								gridGap="10px"
								mb="50px"
							>
								<Flex
									align="center"
									gridGap="10px"
								>
									<Img src={BrandAssets.hashupLogo} />
									<Text
										fontFamily="Sora"
										fontWeight="800"
										fontSize="30px"
									>
										HashUp
									</Text>
								</Flex>
							</Flex>
							<Flex flexDirection="column">
								<Flex
									fontFamily="Sora"
									fontWeight="600"
									fontSize="14px"
									lineHeight="100%"
									align="center"
									letterSpacing="0.08em"
									textTransform="uppercase"
									gridGap="47px"
									pb="0px"
								>
									<Flex
										textTransform="uppercase"
										gridGap="4px"
									>
										{t('footer.our')}
										<Text color={colors.primary}> {t('footer.socialMedia')}</Text>
									</Flex>
									<FooterSocials />
								</Flex>
								<Newsletter mobile={false} />
							</Flex>
						</Flex>
						<Link to="/">
							<Flex
								gridGap="15px"
								fontFamily="Sora"
								fontSize="14px"
								mb="60px"
								align="center"
							>
								HashUp.it{' '}
								<Flex
									bgColor={colors.primary}
									w="17px"
									h="1px"
								/>
								{t('footer.goToHomepage')}
							</Flex>
						</Link>
						<Grid
							templateColumns="repeat(3, 1fr)"
							templateRows="repeat(2, 1fr)"
							fontFamily="Sora"
							fontSize="13px"
							pb="0px"
							m="0px"
						>
							<GridItem
								display="flex"
								flexDir="column"
								gridGap="30px"
							>
								<CompanyInformation t={t} />
							</GridItem>
							<GridItem
								display="flex"
								flexDir="column"
								gridGap="30px"
							>
								<GridItem>
									<FooterHeading>HashUp</FooterHeading>
									<Flex
										gridGap="9px"
										flexDir="column"
									>
										<Text>{t('footer.links.team')}</Text>
										<Text>{t('footer.links.media')}</Text>
										<Text>{t('footer.links.about')}</Text>
									</Flex>
								</GridItem>
							</GridItem>
						</Grid>
					</Flex>
				</Flex>
				<Box
					w="100%"
					h="0.5px"
					bgColor="#6D6D6D"
					opacity="0.6"
					mt="-100px"
				/>
				<Flex
					bgColor="black"
					justify="center"
					m="0"
				>
					<Flex
						w="1200px"
						color="white"
						justify="space-between"
						pt="-1000px"
						mt="-30px"
					>
						<Copyright />
					</Flex>
				</Flex>
			</Box>
			{/* mobile */}
			<Flex
				display={{ base: 'flex', md: 'none' }}
				flexWrap="wrap"
				mt="2rem"
				justify="center"
			>
				<Flex
					align="center"
					w="100%"
					justify="center"
					mb="15px"
				>
					<Image
						maxH="15px"
						src={BrandAssets.hodlLogo}
					/>
				</Flex>
				<Flex
					mb="25px"
					fontSize="12px"
					justify="center"
					w="100%"
				>
					<FooterSocials />
				</Flex>
				<CompanyInformation
					t={t}
					isMobile
				/>
				<Newsletter mobile />
				<Copyright />
			</Flex>
		</>
	);
}
